import { getDataProps } from './dataProps';

export const sellerDetailView = (adIds: number[]) => {
    const { urls } = getDataProps();
    return `${urls.internal.statusSell}?itemIds=${adIds.join(',')}`;
};

export const buyerDetailView = (transactionId: string) => {
    const { urls } = getDataProps();
    return `${urls.internal.statusBuy}/${transactionId}`;
};
